import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/components/Layout.vue'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' }
      },
      {
        path: 'recharge',
        name: 'Recharge',
        component: () => import('@/views/recharge/index.vue'),
        meta: { title: '充值管理', icon: 'el-icon-money' }
      },
      {
        path: 'withdrawal',
        name: 'Withdrawal',
        component: () => import('@/views/withdrawal/index.vue'),
        meta: { title: '核销管理', icon: 'el-icon-s-goods' }
      },
      {
        path: 'machine',
        name: 'Machine',
        component: () => import('@/views/machine/index.vue'),
        meta: { title: '设备管理', icon: 'el-icon-set-up' }
      },
      {
        path: 'coupon',
        name: 'Coupon',
        component: () => import('@/views/coupon/index.vue'),
        meta: { title: '零件券管理', icon: 'el-icon-tickets' }
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('@/views/report/index.vue'),
        meta: { title: '报表统计', icon: 'el-icon-s-data', permission: 'view_report' }
      },
      {
        path: 'role',
        name: 'Role',
        component: () => import('@/views/role/index.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom', permission: 'manage_roles' }
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/admin/index.vue'),
        meta: { title: '员工管理', icon: 'el-icon-s-check', permission: 'manage_admins' }
      },
      {
        path: 'recharge-confirm',
        name: 'RechargeConfirm',
        component: () => import('@/views/recharge-confirm/index.vue'),
        meta: { title: '充值确认', icon: 'el-icon-s-claim', permission: 'confirm_recharge' }
      },
      {
        path: 'withdrawal-confirm',
        name: 'WithdrawalConfirm',
        component: () => import('@/views/withdrawal-confirm/index.vue'),
        meta: { title: '核销确认', icon: 'el-icon-s-claim', permission: 'confirm_withdrawal' }
      },
      {
        path: 'sms-record',
        name: 'SmsRecord',
        component: () => import('@/views/sms-record/index.vue'),
        meta: { title: '短信记录', icon: 'el-icon-message', permission: 'manage_admins' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = store.state.token
  if (to.meta && to.meta.public) {
    next()
  } else if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router
